<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Geoplanos</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'geoplanos'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
          </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer size="xl">
       <div class="modal-body">
        <b-row>
          <b-col md="6">
            Nombre
            <b-form-input
              id="NOMBRE"
              v-model="selectedItem.NOMBRE"
              placeholder="Nombre..."
              :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
              !$v.selectedItem.NOMBRE.$error : null"
              aria-describedby="nombre-feedback" />
              <b-form-invalid-feedback id="nombre-feedback">
              Este campo es requerido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col md="6">
            <div>
              Tipo<select class="form-control" v-model="selectedItem.TIPO_GEOPLANO">
                <option value="0">Cuadrangular</option>
                <option value="1">Circular</option>
              </select>
            </div>
          </b-col>
        </b-row>

        <br/>

        <b-row>
          <b-col md="4">
            <div >
              Función<select class="form-control" v-model="selectedItem.FUNCION">
                <option value="0">Modelo</option>
                <option value="1">Respuesta</option>
              </select>
            </div>
          </b-col>
          <b-col md="2">
            Filas
            <b-form-input
              id="FILAS"
              v-model="selectedItem.FILAS"
              type="number"
              placeholder="Filas..."
              :state="($v.selectedItem.FILAS.$dirty && submitted)?
              !$v.selectedItem.FILAS.$error : null"
              aria-describedby="filas-feedback" />
              <b-form-invalid-feedback id="filas-feedback">
              Este campo es requerido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col md="2">
            Columnas
            <b-form-input
              id="COLUMNAS"
              type="number"
              v-model="selectedItem.COLUMNAS"
              placeholder="Columnas..."
              :state="($v.selectedItem.COLUMNAS.$dirty && submitted)?
              !$v.selectedItem.COLUMNAS.$error : null"
              aria-describedby="columnas-feedback" />
              <b-form-invalid-feedback id="columnas-feedback">
              Este campo es requerido.
            </b-form-invalid-feedback>
          </b-col>
          <b-col md="4">
            <div>
              Tipo de figura<select class="form-control" v-model="selectedItem.TIPO_FIGURA">
                <option value="0">Trazos</option>
                <option value="1">Imagen</option>
              </select>
            </div>
          </b-col>
        </b-row>

        <br>
        <hr>

        <b-row>
          <b-col  style="text-align:center">
            <strong>Figuras del geoplano</strong>
            <br/>
            Número de figuras <select v-model="selectedNumElements">
              <option v-for="option in nshapes" v-bind:key="option.value">
                {{ option.value }}
              </option>
            </select>
          </b-col>
        </b-row>

        <div v-for="option in nshapes" v-bind:key="option.value">
          <div v-if="option.value<= selectedNumElements">
            <br />
            <b-row>
              <b-col md="4">
                <div>
                  Tipo de figura<select class="form-control" v-model="selectedItem.TIPO_FIGURA" disabled>
                    <option value="0">Trazos</option>
                    <option value="1">Imagen</option>
                  </select>
                </div>
              </b-col>
              <b-col md="4" v-if="parseInt(selectedItem.TIPO_FIGURA) === 0">
                <div>
                  Color del trazo<select class="form-control" v-model="arrayEleOperation[option.value - 1].COLOR_TRAZO">
                    <option value="0">Por defecto</option>
                    <option value="1">Rojo</option>
                    <option value="2">Azul</option>
                    <option value="3">Amarillo</option>
                    <option value="4">Verde</option>
                    <option value="5">Negro</option>
                  </select>
                </div>
              </b-col>
              <b-col md="4" v-if="parseInt(selectedItem.TIPO_FIGURA) === 0">
                <div>
                  Color de relleno<select class="form-control" v-model="arrayEleOperation[option.value - 1].COLOR_RELLENO">
                    <option value="0">Sin relleno</option>
                    <option value="1">Rojo</option>
                    <option value="2">Azul</option>
                    <option value="3">Amarillo</option>
                    <option value="4">Verde</option>
                    <option value="5">Negro</option>
                  </select>
                </div>
              </b-col>
              <b-col md="8" v-if="parseInt(selectedItem.TIPO_FIGURA) === 1">
                <div>
                  Imagen figura
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <div class="image">
                      <img v-bind:id="'IMAGENES_ID_URL' + option.value" :src="getTranslation(arrayEleOperation[option.value - 1].IMAGEN)" alt="img"
                      style="width:auto;max-height:110px" class="img-fluid">
                  </div>
                    <searchimages class="pl-2" v-bind:idModal="option.value"
                      v-on:selected="onSelectedImage($event, option.value - 1)">
                    </searchimages>
                  </div>
                  <div>
                  <b-form-input
                      v-bind:id="'IMAGENES_ID' + option.value"
                      v-model="arrayEleOperation[option.value - 1].IMAGENES_ID"
                      :state="($v.arrayEleOperation.$each[option.value - 1].IMAGENES_ID.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].IMAGENES_ID.$error : null"
                      v-bind:aria-describedby="'IMAGENES_ID-feedback' + option.value" style="display: none"/>
                  <b-form-invalid-feedback v-bind:id="'IMAGENES_ID-feedback' + option.value">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
                </div>
              </b-col>
            </b-row>
            <br />
            <div class="p-4 trazos-area" v-if="parseInt(selectedItem.TIPO_FIGURA) === 0">
              <b-row>
                <b-col  style="text-align:center">
                  <strong class="text-muted">Trazos de la figura</strong>
                  <b-button @click="removeTrazo(option.value - 1)" class="btn btn-danger ml-2" size="sm">
                    -
                  </b-button>
                  <b-button @click="addTrazoToShape(option.value - 1)" class="btn btn-primary ml-2" size="sm">
                    +
                  </b-button>
                </b-col>
              </b-row>
              <div v-for="trazo in arrayEleOperation[option.value - 1].trazosShape" v-bind:key="trazo.ID">
                <br/>
                <b-row class="align-items-center trazos-figura">
                  <b-col md="2">
                      <div>
                        <select class="form-control" v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].TIPO_TRAZO">
                          <option value="R">Recto</option>
                          <option value="C">Curvo</option>
                          <option value="A">Area</option>
                          <option value="P">Punto</option>
                        </select>
                      </div>
                  </b-col>
                  <b-col md="1" class="mr-4">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                        v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].VISIBLE"
                        v-bind:id="'VISIBLE' + option.value + '_' + trazo.ID">
                        <label class="custom-control-label" v-bind:for="'VISIBLE' + option.value + '_' + trazo.ID">Visible</label>
                      </div>
                  </b-col>
                  <b-col class="p-1 m-0 mx-2 d-flex align-items-center">
                    <strong class="pr-2">A:</strong>
                    <b-form-input type="number" placeholder="X"
                      v-bind:id="'X_A' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].X_A"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_A.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_A.$error : null"
                      v-bind:aria-describedby="'X_A-feedback' + option.value"/>
                    <b-form-input type="number" placeholder="Y"
                      v-bind:id="'Y_A' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].Y_A"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_A.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_A.$error : null"
                      v-bind:aria-describedby="'Y_A-feedback' + option.value"/>
                  </b-col>
                  <b-col class="p-1 m-0 mx-2 d-flex align-items-center">
                    <strong class="pr-2">B:</strong>
                    <b-form-input type="number" placeholder="X"
                      v-bind:id="'X_B' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].X_B"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_B.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_B.$error : null"
                      v-bind:aria-describedby="'X_B-feedback' + option.value"/>
                    <b-form-input type="number" placeholder="Y"
                      v-bind:id="'Y_B' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].Y_B"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_B.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_B.$error : null"
                      v-bind:aria-describedby="'Y_B-feedback' + option.value"/>
                  </b-col>
                  <b-col class="p-1 m-0 mx-2 d-flex align-items-center">
                    <strong class="pr-2">C:</strong>
                    <b-form-input type="number" placeholder="X"
                      v-bind:id="'X_C' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].X_C"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_C.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_C.$error : null"
                      v-bind:aria-describedby="'X_C-feedback' + option.value"/>
                    <b-form-input type="number" placeholder="Y"
                      v-bind:id="'Y_C' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].Y_C"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_C.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_C.$error : null"
                      v-bind:aria-describedby="'Y_C-feedback' + option.value"/>
                  </b-col>
                  <b-col class="p-1 m-0 mx-2 d-flex align-items-center">
                    <strong class="pr-2">D:</strong>
                    <b-form-input type="number" placeholder="X"
                      v-bind:id="'X_D' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].X_D"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_D.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].X_D.$error : null"
                      v-bind:aria-describedby="'X_D-feedback' + option.value"/>
                    <b-form-input type="number" placeholder="Y"
                      v-bind:id="'Y_D' + option.value"
                      v-model="arrayEleOperation[option.value - 1].trazosShape[trazo.ID].Y_D"
                      :state="($v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_D.$dirty && submitted)?
                      !$v.arrayEleOperation.$each[option.value - 1].trazosShape.$each[trazo.ID].Y_D.$error : null"
                      v-bind:aria-describedby="'Y_D-feedback' + option.value"/>
                  </b-col>
                </b-row>
              </div>
            </div>
            <hr/>

          </div>
        </div>

        <label for="Tag">
        <br>
        Etiquetas</label>
          <div>
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            :autocomplete-items="autocompleteItems"
            @tags-changed="update"
          />
        </div>
        <div class="modal-footer">
          <button type="button" @click="save"
          class="btn btn-info btn-round waves-effect">
            Guardar</button>
          <b-button class="btn btn-default btn-round waves-effect" block
          @click="$bvModal.hide('info-modal')">Cerrar</b-button>
        </div>
      </div>
    </b-modal>
</div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { required } from 'vuelidate/lib/validators';
import searchimages from '../images/SearchImages.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  components: {
    VueTagsInput,
    searchimages,
    ResourceSearchs,
  },
  mixins: [searchMixin, translationMixin],
  name: 'gridGeoplanos',
  created() {
    this.bindArrayEleOperation();
  },
  data() {
    return {
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      arrayEleOperation: [],
      selectedNumElements: 1,
      nshapes: [
        { value: 1 },
        { value: 2 },
        { value: 3 },
        { value: 4 },
        { value: 5 },
        { value: 6 },
        { value: 7 },
        { value: 8 },
        { value: 9 },
        { value: 10 },
        { value: 11 },
        { value: 12 },
        { value: 13 },
        { value: 14 },
        { value: 15 },
        { value: 16 },
        { value: 17 },
        { value: 18 },
        { value: 19 },
        { value: 20 },
        { value: 21 },
        { value: 22 },
        { value: 23 },
        { value: 24 },
        { value: 25 },
        { value: 26 },
        { value: 27 },
        { value: 28 },
        { value: 29 },
        { value: 30 },
      ],
      fields: [
        { key: 'ID', label: 'ID' },
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'TIPO_GEOPLANO', label: 'Tipo' },
        { key: 'FUNCION', label: 'Función' },
        { key: 'FILAS', label: 'Filas' },
        { key: 'COLUMNAS', label: 'Columnas' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        TIPO_GEOPLANO: 0,
        FUNCION: 0,
        FILAS: 4,
        COLUMNAS: 4,
        TIPO_FIGURA: 0,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      TIPO_GEOPLANO: {
        required,
      },
      FUNCION: {
        required,
      },
      FILAS: {
        required,
      },
      COLUMNAS: {
        required,
      },
    },
    arrayEleOperation: {
      $each: {
        IMAGENES_ID: {
          required,
        },
        trazosShape: {
          $each: {
            X_A: {
              required,
            },
            Y_A: {
              required,
            },
            X_B: {
              required,
            },
            Y_B: {
              required,
            },
            X_C: {
              required,
            },
            Y_C: {
              required,
            },
            X_D: {
              required,
            },
            Y_D: {
              required,
            },
          },
        },
      },
    },
  },
  methods: {
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected, index) {
      this.arrayEleOperation[index].IMAGENES_ID = itemSelected.ID;
      this.arrayEleOperation[index].IMAGEN = [];
      this.arrayEleOperation[index].IMAGEN = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', index + 1);
    },
    bindArrayEleOperation() {
      this.arrayEleOperation = [];
      for (let i = 0; i < 20; i += 1) {
        this.arrayEleOperation.push({
          ID: -1,
          POSICION: i + 1,
          TIPO_FIGURA: 0,
          COLOR_TRAZO: 0,
          COLOR_RELLENO: 0,
          IMAGENES_ID: null,
          IMAGEN: [],
          trazosShape: [],
        });
      }
    },
    addTrazoToShape(i) {
      this.arrayEleOperation[i].trazosShape.push({
        ID: this.arrayEleOperation[i].trazosShape.length,
        POSICION: this.arrayEleOperation[i].trazosShape.length + 1,
        TIPO_TRAZO: 'R',
        VISIBLE: false,
        X_A: 0,
        Y_A: 0,
        X_B: 0,
        Y_B: 0,
        X_C: 0,
        Y_C: 0,
        X_D: 0,
        Y_D: 0,
      });
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Nuevo Geoplano';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    removeTrazo(index) {
      this.arrayEleOperation[index].trazosShape.pop();
    },
    limpiar() {
      this.selectedNumElements = 1;
      this.bindArrayEleOperation();
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TIPO_GEOPLANO = 0;
      this.selectedItem.FUNCION = 0;
      this.selectedItem.FILAS = 4;
      this.selectedItem.COLUMNAS = 4;
      this.selectedItem.TIPO_FIGURA = 0;
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsgeoplanos/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('geoplanos/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.limpiar();
      this.submitted = false;
      this.infoModal.title = 'Editar Geoplano';
      this.loading = true;
      try {
        const response = await this.axios.get('geoplanos/getgeoplanos', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.geoplano;
        this.selectedNumElements = response.data.figuras.length;
        response.data.figuras.forEach((element) => {
          this.arrayEleOperation[element.KEYSEQUENCE] = {
            ID: element.ID != null ? element.ID : -1,
            POSICION: element.KEYSEQUENCE,
            TIPO_FIGURA: element.TIPO_FIGURA,
            COLOR_TRAZO: element.COLOR_TRAZO,
            COLOR_RELLENO: element.COLOR_RELLENO,
            IMAGENES_ID: element.IMAGENES_ID,
            IMAGEN: element.IMAGEN,
            trazosShape: element.trazosShape,
          };
        });
        // COPY data from first element, as all should be the same
        this.selectedItem.TIPO_FIGURA = this.arrayEleOperation[0].TIPO_FIGURA;
        this.$v.selectedItem.$reset();
        this.$v.arrayEleOperation.$reset();
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el geoplano', { type: 'warning' });
      }
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      this.$v.arrayEleOperation.$touch();
      const NUM_ELEMENTOS = parseInt(this.selectedNumElements, 10);
      let errorarrayelement = false;
      if (parseInt(this.selectedItem.TIPO_FIGURA, 10) === 1) { // Validar cuando el array contiene imagenes
        // Iterar sobre arrayEleOperation
        for (let i = 0; i < NUM_ELEMENTOS; i += 1) {
          if (this.$v.arrayEleOperation.$each.$iter[i].$anyError) {
            errorarrayelement = true;
            break;
          }
        }
      } else {
        for (let i = 0; i < NUM_ELEMENTOS; i += 1) {
          if (this.$v.arrayEleOperation.$each.$iter[i].trazosShape.$anyError) {
            errorarrayelement = true;
            break;
          }
        }
      }
      if (this.$v.selectedItem.$anyError || errorarrayelement) {
        return;
      }
      this.loading = true;
      const elementsshape = [];
      this.arrayEleOperation.forEach((element) => {
        if (element.POSICION <= NUM_ELEMENTOS) {
          elementsshape.push({
            // ID: element.ID,
            POSICION: element.POSICION,
            TIPO_FIGURA: this.selectedItem.TIPO_FIGURA,
            COLOR_TRAZO: element.COLOR_TRAZO,
            COLOR_RELLENO: element.COLOR_RELLENO,
            IMAGENES_ID: element.IMAGENES_ID,
            trazosShape: element.trazosShape,
          });
        }
      });
      const templateData = {
        ID: this.selectedItem.ID || -1,
        NOMBRE: this.selectedItem.NOMBRE,
        TIPO_GEOPLANO: this.selectedItem.TIPO_GEOPLANO,
        FUNCION: this.selectedItem.FUNCION,
        FILAS: this.selectedItem.FILAS,
        COLUMNAS: this.selectedItem.COLUMNAS,
        FIGURASGEOPLANO: elementsshape,
      };
      try {
        const response = await this.axios.post('geoplanos/store', templateData);
        if (response.data.status === 'success') {
          // Solo si esta creando agrego el evento
          if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
            const bc = new BroadcastChannel('new_resource_geoplano');
            bc.postMessage({
              ID: response.data.id,
              NOMBRE: this.selectedItem.NOMBRE,
              TIPO_GEOPLANO: this.selectedItem.TIPO_GEOPLANO,
              FUNCION: this.selectedItem.FUNCION,
              FILAS: this.selectedItem.FILAS,
              COLUMNAS: this.selectedItem.COLUMNAS,
            });
          }

          const url = `Tagsgeoplanos/deleteTags/${response.data.id}`;
          const url2 = 'Tagsgeoplanos/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idtexto: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          await this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('geoplanos', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsgeoplanos/findByGeoplano/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_geoplano_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }

  .trazos-area {
    border: 1px solid #cdcdcd;
    border-radius: 0.3rem;
  }

  /* Chrome, Safari, Edge, Opera */
  .trazos-figura input::-webkit-outer-spin-button,
  .trazos-figura input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  .trazos-figura input[type=number] {
    -moz-appearance:textfield;
  }
</style>
